import {useContext, useEffect} from "react";
import {FriendContext, SocketContext} from "../../App";
import sound from "../../accets/sound.mp3"
import sound_task from "../../accets/sound_task.mp3"
import {fetchChat} from "../../http/ChatAPI";
import {fetchAllTasks, fetchOneTask} from "../../http/TaskAPI";
import {Context} from "../../index";
import {fetchComment} from "../../http/CommentsAPI";
import {fetchFiles} from "../../http/FileAPI";
import {fetchStatement} from "../../http/StatementAPI";
import {fetchTracking} from "../../http/TrackingAPI";
import {fetchSetting} from "../../http/SettingsAPI";

const useSocketSetup = () => {

    const {
        setFriendList,
        messages,
        setMessages,
        setOnlineUsers,
        closeTask,
        setCloseTask,
        setOneTask
    } = useContext(FriendContext)
    const {socket} = useContext(SocketContext)
    const {taskStore, fileStore, commentStore, statementStore, trackingStore, settingStore} = useContext(Context)

    useEffect(() => {
        socket.connect()
        socket.on("getonline", (users) => {
            setOnlineUsers(users)
        })
        socket.on("newChat", (chats) => {
            fetchChat().then(data => setFriendList(data))
        })
        socket.on("newTaskAllProd", (task) => {
            fetchAllTasks().then(data => taskStore.setTask(data))
        })
        socket.on("newComments", (comments) => {
            fetchComment().then(data => commentStore.setComments(data))
        })
        socket.on("newFile", (file) => {
            fetchFiles().then(data => fileStore.setFile(data))
        })
        socket.on("updateStatement", (file) => {
            fetchStatement().then(data => statementStore.setStatement(data))
        })
        socket.on("closeMyTask", (updatedTask) => {
            setCloseTask([...closeTask, updatedTask])
        })
        socket.on("newMessage", (newMessage) => {
            const notificationAudio = new Audio(sound)
            notificationAudio.play()
            setMessages([...messages, newMessage])
        })
        socket.on("MyMessageToChat", (newMessage) => {
            setMessages([...messages, newMessage])
        })

        socket.on("newTrack", (track) => {
            fetchTracking().then(data => trackingStore.setTrackings(data))
        })

        socket.on("delTracking", (track) => {
            fetchTracking().then(data => trackingStore.setTrackings(data))
        })

        socket.on("newSetting", (setting) => {
            fetchSetting().then(data => settingStore.setSetting(data))
        })

        socket.on("newMyTask", (task) => {
            const notificationAudioTask = new Audio(sound_task)
            notificationAudioTask.play()
        })
        socket.on("isReadMsg", (msg) => {
            const updateMessage = messages.map((obj) => {
                if (obj.id === msg.id) {
                    return {
                        ...obj,
                        id: msg.id,
                        firstSocketId: msg.firstSocketId,
                        secondSocketId: msg.secondSocketId,
                        message: msg.message,
                        chatId: msg.chatId,
                        isRead: msg.isRead,
                        createdAt: msg.createdAt
                    }
                }
                return obj
            })
            setMessages(updateMessage)
        })
        socket.on("isReadMyMsg", (msg) => {
            const updateMessage = messages.map((obj) => {
                if (obj.id === msg.id) {
                    return {
                        ...obj,
                        id: msg.id,
                        firstSocketId: msg.firstSocketId,
                        secondSocketId: msg.secondSocketId,
                        message: msg.message,
                        chatId: msg.chatId,
                        isRead: msg.isRead,
                        createdAt: msg.createdAt
                    }
                }
                return obj
            })
            setMessages(updateMessage)
        })
        return () => {
            socket.off("newChat")
            socket.off("newMessage")
            socket.off("isReadMsg")
            socket.off("isReadMyMsg")
            socket.off("newMyTask")
            socket.off("MyMessageToChat")
            socket.off("newTaskAllProd")
            socket.off("newFile")
            socket.off("newComments")
            socket.off("updateStatement")
            socket.off("closeMyTask")
            socket.off("newTrack")
            socket.off("delTracking")
            socket.off("newSetting")
            socket.close()
        }

    }, [setFriendList, setMessages, messages, socket])
}

export default useSocketSetup